import { FlexColumn } from '@elementary/common-ui/components';
import { SxProps, Typography, Theme } from '@mui/material';
import dayjs from 'dayjs';
import styled from 'styled-components';
import {
  fontFamily,
  fontSize,
  fontWeight,
} from '@elementary/common-ui/style/utils';
import { GPGKey, GPGKeyStatus } from '../types';
import GPGKeyStatusChip from './GPGKeyStatusChip';

const TypographyBody = ({
  children,
  sx,
}: {
  children: React.ReactNode;
  sx?: SxProps<Theme>;
}) => (
  <Typography variant="body2" sx={sx}>
    {children}
  </Typography>
);

const FingerprintTypography = styled(TypographyBody)`
  font-family: ${fontFamily('mono')};
  font-size: ${fontSize('xs')};
  word-break: break-all;
`;

const GPGKeyDetails = ({ gpgKey }: { gpgKey: GPGKey }) => (
  <FlexColumn sx={{ gap: 1 }}>
    <TypographyBody sx={{ fontWeight: fontWeight('medium') }}>
      Key Details:
    </TypographyBody>

    <FlexColumn sx={{ gap: 0.5, ml: 1 }}>
      <TypographyBody>
        <strong>Key ID:</strong> {gpgKey.keyId}
      </TypographyBody>
      <TypographyBody>
        <strong>Fingerprint:</strong>
      </TypographyBody>
      <FingerprintTypography>{gpgKey.fingerprint}</FingerprintTypography>
      <TypographyBody>
        <strong>Name:</strong> {gpgKey.keyName}
      </TypographyBody>
      <TypographyBody>
        <strong>Email:</strong> {gpgKey.keyEmail}
      </TypographyBody>
      <TypographyBody>
        <strong>Status:</strong> <GPGKeyStatusChip gpgKey={gpgKey} />
      </TypographyBody>

      {gpgKey.status !== GPGKeyStatus.revoked && (
        <>
          <TypographyBody>
            <strong>
              {gpgKey.expiresAt && dayjs(gpgKey.expiresAt).isBefore(dayjs())
                ? 'Expired on:'
                : 'Expires on:'}
            </strong>{' '}
            {gpgKey.expiresAt ? dayjs(gpgKey.expiresAt).format('L') : 'Never'}
          </TypographyBody>
        </>
      )}
    </FlexColumn>
  </FlexColumn>
);

export default GPGKeyDetails;
